import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from '../server/layout/Row/index';
import { Icon } from '../system/icons';
import { inputBase } from '../system/inputBase';
const noFillAttrs = {
    'data-lpignore': 'true',
    'data-1p-ignore': 'true',
    'data-bwignore': 'true',
    'data-form-type': 'other',
    autoComplete: 'off',
};
export function Input({ icon, leading, trailing, type = 'text', invalid, style, ...rest }) {
    if (icon || leading || trailing) {
        // The slot-wrapper case needs `display: flex` so the inner <input flex:1>
        // grows to fill the row. `inputBase.display === 'block'` is meant for the
        // bare-input case below; in this branch the Row's flex layout owns
        // distribution, so we re-assert it after spreading inputBase.
        return (_jsxs(Row, { gap: "none", align: "center", style: {
                ...inputBase,
                display: 'flex',
                padding: 0,
                paddingLeft: 'var(--space-md)',
                paddingRight: 'var(--space-md)',
                borderColor: invalid ? 'var(--destructive)' : 'var(--border-strong)',
                ...style,
            }, children: [icon ? (_jsx(Icon, { size: 16, style: { color: 'var(--muted-foreground)', marginRight: 'var(--space-sm)' }, children: icon })) : (leading), _jsx("input", { ...noFillAttrs, type: type, style: {
                        flex: 1,
                        border: 'none',
                        outline: 'none',
                        padding: 'var(--space-sm) 0',
                        font: 'var(--type-input)',
                        color: 'var(--foreground)',
                        background: 'transparent',
                        minWidth: 0,
                    }, ...rest }), trailing] }));
    }
    return (_jsx("input", { ...noFillAttrs, type: type, style: {
            ...inputBase,
            borderColor: invalid ? 'var(--destructive)' : 'var(--border-strong)',
            ...style,
        }, ...rest }));
}
//# sourceMappingURL=Input.js.map